import React from 'react';
const bannerText = <>
    🔥 Nuevo precio:{' '}
    <span style={{
    textDecoration: 'line-through',
    opacity: 0.8
  }} data-id="element-131">
      $60.999
    </span>{' '}
    <span style={{
    color: '#FFD700'
  }} data-id="element-132">
      $14.999
    </span>{' '}
    · 🎉 75% OFF · 💳 3 cuotas sin interés con Mercado Pago
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </>;
export function TopBanner() {
  return <>
      <div className="relative z-50 bg-[#2B3654]" style={{
      color: '#fff',
      padding: '20px 0',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '64px'
    }} data-id="element-133">
        <div style={{
        whiteSpace: 'nowrap',
        display: 'inline-block',
        animation: 'deslizar 20s linear infinite',
        fontStyle: 'italic',
        fontWeight: 'bold'
      }} className="text-[28px] font-sans" data-id="element-134">
          🔥🔥 Nuevo precio: · 🎉 50% OFF · 💳 3 cuotas sin interés con Mercado
          Pago       🔥🔥 Nuevo precio: · 🎉 50% OFF · 💳 3 cuotas sin interés
          con Mercado Pago       🔥🔥 Nuevo precio: · 🎉 50% OFF · 💳 3 cuotas
          sin interés con Mercado Pago
        </div>
      </div>
      <style data-id="element-135">
        {`
          @keyframes deslizar {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-33.33%); }
          }
        `}
      </style>
    </>;
}